import 'vue-toast-notification/dist/theme-default.css'
import 'froala-editor/css/third_party/embedly.min.css'
import 'froala-editor/css/third_party/font_awesome.min.css'
import 'froala-editor/css/third_party/image_tui.min.css'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'vue-select/dist/vue-select.css';
import 'swiper/css/bundle';
import Vue from 'vue'
import VueFeather from 'vue-feather'
import VueSocketIOExt from 'vue-socket.io-extended'
import { io } from 'socket.io-client'
import App from './app.vue'
import store from './store/index'
import router from './router/index'
import BootstrapVue from 'bootstrap-vue'
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import './configs/http'
import TextInput from './components/Common/TextInput.vue'
import PhoneInput from './components/Common/PhoneInput.vue'
import UploadImage from './components/Common/UploadImage.vue'
import UploadFile from './components/Common/UploadFile.vue'
import UploadNonConvertImage from './components/Common/UploadNonConvertImage.vue'
import UploadNonConvertImageWithAI from './components/Common/UploadNonConvertImageWithAI.vue'
import CropperModal from './components/Common/CropperModal.vue' 
import TextEditor from './components/Common/TextEditor.vue'
import TextEditor2 from './components/Common/TextEditor2.vue'
import NumberPack from './components/Common/NumberPack.vue'
import ButtonRenderer from './components/Common/ButtonRenderer.vue'
import ButtonRenderer2 from './components/Editors/ButtonRenderer2.vue'
import IconPicker from './components/Common/IconPicker.vue'
import FaIcon from './components/Common/FaIcon.vue'
import ElementsPicker from './components/Common/ElementsPicker.vue'
import Editor from './components/Common/Editor.vue'
import Switches from 'vue-switches'
import ColorInput from './components/Common/ColorInput.vue'
import NumberInput from './components/Common/NumberInput.vue'
import NumberInput2 from './components/Common/NumberInput2.vue'
import AlignInput from './components/Common/AlignInput.vue'
import VideoInput from './components/Common/VideoInput.vue'
import ImageInput from './components/Common/ImageInput.vue'
import ImageInput2 from './components/Common/ImageInput2.vue'
import LogoInput from './components/Common/LogoInput.vue'
import LogoInput2 from './components/Common/LogoInput2.vue'
import ActionButton from './components/Common/ActionButton.vue'
import FontSelect from './components/Common/FontSelect.vue'
import VueToast from 'vue-toast-notification'
import 'froala-editor/js/plugins.pkgd.min'
import 'froala-editor/js/third_party/embedly.min'
import 'froala-editor/js/third_party/font_awesome.min'
import 'froala-editor/js/third_party/image_tui.min'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import vSelect from 'vue-select'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import _ from 'lodash';

// Filters
import './filters/datetime'
import './filters/phone'
import './filters/camelcase'
import './filters/numberk'
import './filters/numbercomma'
import './filters/timesince'

Vue.mixin({
  methods: {
    formatNational: (val) => {
      if (!val) return "";
      if (!val.startsWith("+")) val = "+" + val;

      const phoneNumber = parsePhoneNumberFromString(val);
      if (phoneNumber)
      {
        if (['US', 'CA'].includes(phoneNumber.country))
        {
          return phoneNumber.formatNational()
        } else {
          return phoneNumber.formatInternational()
        }
      }
      return val
    },
    fileSize: (fileSizeInBytes) => {
      var i = -1;
      var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
      do {
          fileSizeInBytes = fileSizeInBytes / 1024;
          i++;
      } while (fileSizeInBytes > 1024);
  
      return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
    },
    difference(object, base) {
      function changes(object, base) {
        return _.transform(object, function(result, value, key) {
          if (base)
          {
            let baseValue = base[key];
            if (key === 'message') {
              if (value)
                value = value.replace( /(<([^>]+)>)/ig, '').replace(/[^a-zA-Z0-9 ]/gi, '').trim();
              if (baseValue)
                baseValue = baseValue.replace( /(<([^>]+)>)/ig, '').replace(/[^a-zA-Z0-9 ]/gi, '').trim();
            }
            if (!_.isEqual(value, baseValue) && key !== 'level') {
              let tmp = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
              if (!_.isEmpty(tmp)) {
                result[key] = tmp
              }
            }
          } else {
            result[key] = value
          }
        });
      }
      return changes(object, base);
    },
  }
});

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = (event) => {
      // here I check that click was outside the el and his children
      if ((!(el === event.target || el.contains(event.target)))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: (el) => {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
});

Vue.config.productionTip = false
Vue.config.devtools = false
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule])
})
extend('customurl', {
  validate: (value) => {
    return !value.trim().startsWith('www.') && !value.trim().startsWith('http') && value.match(/^[a-z0-9|-]{1,61}[a-z0-9|-](?:\.[a-z0-9|-]{2,})+$/)
  },
  message: 'Domain format is invalid.'
})
extend('subdomain', {
  validate: (value) => {
    return value && value.length < 63 && value.match(/^[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/)
  },
  message: 'Subdomain format is invalid.'
})
extend('include', {
  params: ['word'],
  validate: (value, { word }) => {
    return value.trim().indexOf(word) !== -1
  },
  message: `The field required {word}`
})
Vue.use(VueSocketIOExt, io(process.env.VUE_APP_SOCKET_URL, {
  transports: ['websocket']
}))
Vue.use(VueToast, { position: 'bottom' })
Vue.use(BootstrapVue)
Vue.use(ElementUI)
Vue.component('BirthdayInput', () => import(`@components/Common/BirthdayInput.vue`))
Vue.component('MergeFieldsGroup', () => import(`@components/Common/MergeFieldsGroup.vue`))
Vue.component('TextAreaAction', () => import(`@components/Common/TextAreaAction.vue`))
Vue.component('TextEditorAction', () => import(`@components/Common/TextEditorAction.vue`))
Vue.component('v-select', vSelect)
Vue.component('UploadImage', UploadImage)
Vue.component('UploadFile', UploadFile)
Vue.component('UploadNonConvertImage', UploadNonConvertImage)
Vue.component('CropperModal', CropperModal)
Vue.component('UploadNonConvertImageWithAI', UploadNonConvertImageWithAI)
Vue.component('TextEditor', TextEditor)
Vue.component('TextEditor2', TextEditor2)
Vue.component('NumberPack', NumberPack)
Vue.component('ButtonRenderer', ButtonRenderer)
Vue.component('ButtonRenderer2', ButtonRenderer2)
Vue.component('IconPicker', IconPicker)
Vue.component('FaIcon', FaIcon)
Vue.component('ElementsPicker', ElementsPicker)
Vue.component('PhoneInput', PhoneInput)
Vue.component('TextInput', TextInput)
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('Editor', Editor)
Vue.component('Switches', Switches)
Vue.component('ColorInput', ColorInput)
Vue.component('NumberInput', NumberInput)
Vue.component('NumberInput2', NumberInput2)
Vue.component('AlignInput', AlignInput)
Vue.component('VideoInput', VideoInput)
Vue.component('ImageInput', ImageInput)
Vue.component('ImageInput2', ImageInput2)
Vue.component('LogoInput', LogoInput)
Vue.component('LogoInput2', LogoInput2)
Vue.component('ActionButton', ActionButton)
Vue.component('FontSelect', FontSelect)
Vue.component('vue-feather', VueFeather)
new Vue({ router, store, render: (h) => h(App) }).$mount('#ne-app-wrapper')